import request from '@/config/axios'

export interface O2oHomeBrandVO {
  id?: number
  picUrl?: string
}

export const O2oHomeBrandApi = {
  getHomeBrand: async () => {
    return await request.get({ url: '/o2o/marketing/home-brand/get' })
  },
  saveHomeBrand: async (data: O2oHomeBrandVO) => {
    return await request.put({ url: '/o2o/marketing/home-brand/save', data })
  }
}
